<script setup>
import { useI18n } from "vue-i18n"
import { defineAsyncComponent, ref, onMounted } from "vue"

const { t } = useI18n()


const isClient = ref(false)

onMounted(() => {
  isClient.value = true
})


</script>

<template>
  <section class="contact-section">
    <div class="contact-grid">

      <!-- LEFT — FORM -->
      <div class="contact-form-box">
        <h3 class="small-title">{{ t('contactTitle') }}</h3>
        <h1 class="big-title">{{ t('contactHeading') }}</h1>

      <form
  class="contact-form"
  action="https://formspree.io/f/mgoowree"
  method="POST"
>
  <input
    type="text"
    name="name"
    :placeholder="t('yourName')"
    required
  />

  <input
    type="email"
    name="email"
    :placeholder="t('yourEmail')"
    required
  />

  <input
    type="text"
    name="subject"
    :placeholder="t('subject')"
  />

  <textarea
    name="message"
    :placeholder="t('typeMessage')"
    rows="5"
    required
  ></textarea>

  <button type="submit" class="send-button">
    {{ t('submit') }}
  </button>
</form>

      </div>

      <!-- RIGHT — INFO + MAP -->
      <div class="contact-info">
        <p class="description">{{ t('contactDescription') }}</p>

        <div class="info-grid">
          <div class="info-box">
            <h4>{{ t('phoneNumber') }}</h4>
            
            <p>{{ t('phone') }}</p>
            <p>{{ t('phone2') }}</p>
          </div>

          <div class="info-box">
            <h4>{{ t('emailLabel') }}</h4>
            <p>{{ t('emailAddress') }}</p>
          </div>
                         
          <div class="info-box">
            <h4>{{ t('locationLabel') }}</h4>
            <p>{{ t('address') }}</p>
          </div>
        </div>

   <!-- <GoogleMap
          class="map"
          api-key="AIzaSyAOKsQNZ3FsAta_dB9UhkrUv93M9_Xc3jA"
          :center="center"
          :zoom="12"
        >
          <Marker :options="{ position: center }" />
        </GoogleMap>  -->
<div class="map">
<iframe src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d2796.6025231262824!2d-73.66043392329553!3d45.49794833118572!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x4cc919d24f9d3a5d%3A0x8f4071dcaaa4c439!2sNext%20level%20immigration%2C%207965%20Bd%20D%C3%A9carie%2C%20Montr%C3%A9al%2C%20QC%20H4P%202H5!5e0!3m2!1sen!2sca!4v1774151566384!5m2!1sen!2sca"
 width="100%" 
 height="100%" 
 style="border:0;" 
 allowfullscreen="" 
 loading="lazy" 
 referrerpolicy="no-referrer-when-downgrade"></iframe>
 </div>
      </div>

    </div>
  </section>
</template>

<style scoped>
@import url('https://fonts.googleapis.com/css2?family=Montserrat:wght@300;400;600&display=swap');
@import url('https://fonts.googleapis.com/css2?family=Cormorant+Garamond:ital,wght@0,300..700;1,300..700&family=Montserrat:ital,wght@0,100..900;1,100..900&display=swap');
@import url('https://fonts.googleapis.com/css2?family=League+Gothic&display=swap');

body {
  font-family: 'Montserrat', sans-serif;
  font-family: 'League Gothic', sans-serif;
  font-family: 'Cormorant Garamond', sans-serif;
}

/* Layout */
.contact-section {
  color: #283A54;
  margin-top: 10rem;
}

.contact-grid {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 50px;
  margin-bottom: 2rem;
}

/* Left Form Box */
.contact-form-box {
 
  padding: 40px;
}

.small-title {
  color: #6d6c6c;
  font-size: 18px;
  margin-bottom: 5px;
  font-family:  'Montserrat', sans-serif;
}

.big-title {
  font-size: 40px;
  font-weight: bold;
  margin-bottom: 30px;
  font-family:  'Montserrat', sans-serif;
}

.contact-form input,
.contact-form textarea {
  width: 100%;
  background: #ebebeb;
  border: 1px solid #555;
  padding: 12px;
  color: #000;
  margin-bottom: 15px;
  font-family: 'Montserrat', sans-serif;
  font-size: 1rem;
}

.contact-form input:focus,
.contact-form textarea:focus {
  border-color: #888;
  outline: none;
}

.send-button {
  width: 100%;
  padding: 14px 0;
  background: #283A54;
  color: #ffffff;
  border: none;
  cursor: pointer;
  font-weight: bold;
  transition: 0.3s ease;
  font-weight: 300;
  font-family: montserrat, sans-serif;
  font-size:1.5rem;
}

.send-button:hover {
  background: #000000;
}

/* Right Column */
.description {
  color: #000000;
  line-height: 1.6;
  margin-bottom: 30px;
  font-family: 'Montserrat', sans-serif;
  padding: 1rem;
}

.info-grid {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 20px 20px;
  margin-bottom: 30px;
  padding: 1rem ;
}

.info-box h4 {
  font-size: 15px;
  margin-bottom: 5px;
  color: #000000;
  font-family: 'Montserrat', sans-serif;
  font-weight: 400;
}

.info-box p {
  color: #000000;
  font-family: 'Montserrat', sans-serif;
  font-size: 14px;
}

/* Map */
.map {
  width: 100%;
  height: 280px;
  border: none;
  border-radius: 12px;
  display: block;
  padding: 1rem ;
}

/* Mobile Responsive */
@media (max-width: 900px) {
  .contact-grid {
    grid-template-columns: 1fr;
  }
}
</style>
